import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, input, OnInit, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Validators } from '@angular/forms';

import { ButtonModule } from '@hglobal/common';
import { FormBuilder, FormGroup } from '@ngneat/reactive-forms';
import { GroupResolverFormBuilder } from '@ngneat/reactive-forms/lib/form-builder';
import { TranslateModule } from '@ngx-translate/core';

import { OtpFormComponent } from '@pp/common';
import { VerifyEmailPhoneReq } from '@pp/core/auth-store';
import { Account } from '@pp/core/entities';

@Component({
  selector: 'pp-email-phone-verification',
  imports: [CommonModule, OtpFormComponent, ButtonModule, TranslateModule],
  templateUrl: './email-phone-verification.component.html',
  styleUrl: './email-phone-verification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailPhoneVerificationComponent implements OnInit {
  readonly #fb = inject(FormBuilder);
  readonly #cd = inject(ChangeDetectorRef);
  readonly #destroyRef = inject(DestroyRef);
  readonly user = input<Account>();
  readonly back = output<void>();
  // eslint-disable-next-line @angular-eslint/no-output-native
  readonly submit = output<VerifyEmailPhoneReq>();
  readonly resendPhoneCode = output<void>();
  readonly resendEmailCode = output<void>();

  readonly numberSize = 6;

  form: FormGroup<GroupResolverFormBuilder<VerifyEmailPhoneReq>>;

  ngOnInit() {
    this.#initForm();
    this.form.statusChanges.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(() => this.#cd.detectChanges());
  }

  #initForm(): void {
    this.form = this.#fb.group({
      code_email: ['', [Validators.required, Validators.min(this.numberSize)]],
      code_phone: ['', [Validators.required, Validators.min(this.numberSize)]],
    });
  }
}
